import { render, staticRenderFns } from "./DetailVPage.vue?vue&type=template&id=07033cc4&scoped=true&"
import script from "./DetailVPage.vue?vue&type=script&lang=js&"
export * from "./DetailVPage.vue?vue&type=script&lang=js&"
import style0 from "./DetailVPage.vue?vue&type=style&index=0&id=07033cc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07033cc4",
  null
  
)

export default component.exports